import type { Neutral } from "./types";

const neutrals: Neutral[] = [
  { id: "accelgor", image: "neutrals/accelgor.webp", name: "Accelgor", dex: 617 },
  { id: "altaria", image: "neutrals/altaria.webp", name: "Altaria", dex: 334 },
  { id: "baltoy", image: "neutrals/baltoy.webp", name: "Baltoy", dex: 343 },
  { id: "bunnelby", image: "neutrals/bunnelby.webp", name: "Bunnelby", dex: 659 },
  { id: "escavalier", image: "neutrals/escavalier.webp", name: "Escavalier", dex: 589 },
  { id: "groudon", image: "neutrals/groudon.webp", name: "Groudon", dex: 383 },
  { id: "indeedee", image: "neutrals/indeedee.webp", name: "Indeedee", dex: 876 },
  { id: "kyogre", image: "neutrals/kyogre.webp", name: "Kyogre", dex: 382 },
  { id: "natu", image: "neutrals/natu.webp", name: "Natu", dex: 177 },
  { id: "rayquaza", image: "neutrals/rayquaza.webp", name: "Rayquaza", dex: 384 },
  { id: "regidrago", image: "neutrals/regidrago.webp", name: "Regidrago", dex: 895 },
  { id: "regice", image: "neutrals/regice.webp", name: "Regice", dex: 378 },
  { id: "regieleki", image: "neutrals/regieleki.webp", name: "Regieleki", dex: 894 },
  { id: "regirock", image: "neutrals/regirock.webp", name: "Regirock", dex: 377 },
  { id: "registeel", image: "neutrals/registeel.webp", name: "Registeel", dex: 379 },
  { id: "salac", image: "neutrals/salac.webp", name: "Salac Berry" },
  { id: "sitrus", image: "neutrals/sitrus.webp", name: "Sitrus Berry" },
  { id: "xatu", image: "neutrals/xatu.webp", name: "Xatu", dex: 178 },
];

export default neutrals;
